// extracted by mini-css-extract-plugin
export var fileUpload = "_g3-1";
export var modalButton = "_g3-0";